module.exports = "/assets/data/747e2f31b7356226c240894785825a89-CM12.data.json";